import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || '';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: 'Itaobuy Spreadsheet Moda e Abbigliamento: Il Meglio dello Streetwear',
  url: `${siteUrl}/itaobuy-spreadsheet-moda`,
  description: 'Esplora il mondo della moda su itaobuy spreadsheet: hoodie, t-shirt, giacche e pantaloni delle migliori tendenze streetwear.',
  inLanguage: 'it',
  datePublished: '2026-07-14',
  dateModified: '2026-07-14',
  author: { '@type': 'Organization', name: 'Itaobuy Spreadsheet' },
  publisher: { '@type': 'Organization', name: 'Itaobuy Spreadsheet' },
};

export default function ModaPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={jsonLd} />
      <Navbar />
      <main>
        <header className="bg-foreground-950 pt-24 pb-16 md:pt-32 md:pb-20">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <span className="inline-block font-label text-xs uppercase tracking-[0.2em] text-accent-400 bg-accent-500/10 px-3 py-1 rounded-md mb-5">/ MODA</span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-5">
              Itaobuy Spreadsheet Moda e Abbigliamento: Il Meglio dello Streetwear
            </h1>
            <p className="text-background-50/70 text-sm md:text-base">Esplora il mondo della <strong className="text-background-50">moda su itaobuy spreadsheet</strong>: hoodie, t-shirt, giacche e pantaloni delle migliori tendenze streetwear.</p>
          </div>
        </header>

        <article className="max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="space-y-8 text-foreground-700 leading-relaxed">
            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <p className="text-sm text-foreground-600">Torna alla <Link to="/" className="text-primary-600 font-medium hover:underline">homepage</Link> per navigare tutte le categorie moda.</p>
            </div>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Il Meglio dello Streetwear su Itaobuy</h2>
              <p className="mb-4">La categoria <strong className="text-foreground-950">moda e abbigliamento su itaobuy spreadsheet</strong> copre tutto ciò che serve per un guardaroba streetwear completo. Dalle felpe oversize alle t-shirt con stampe esclusive, dalle giacche tecniche ai pantaloni cargo, il database offre una selezione curata dei migliori capi disponibili.</p>
              <p>Ogni prodotto nel database include <strong className="text-foreground-950">foto QC</strong> dettagliate, recensioni verificate e link diretti per l'acquisto. Consulta anche la <Link to="/guida-itaobuy-spreadsheet-italiano" className="text-primary-600 font-medium hover:underline">guida completa</Link> per tutti i consigli sullo shopping.</p>
            </section>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Capi Imprescindibili per Ogni Stagione</h2>
              <p className="mb-4">Che tu stia cercando un <strong className="text-foreground-950">hoodie</strong> per l'inverno o una <strong className="text-foreground-950">t-shirt</strong> leggera per l'estate, il database itaobuy ha sempre le migliori opzioni. La chiave è saper scegliere: controlla i materiali, le taglie e le recensioni prima di ordinare.</p>
              <p>Per consigli sulla sicurezza degli acquisti, leggi la <Link to="/itaobuy-e-sicuro" className="text-primary-600 font-medium hover:underline">guida alla sicurezza</Link>.</p>
            </section>

            <div className="bg-primary-50 border border-primary-200 rounded-2xl p-6 md:p-8 my-10">
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">Esplora la Moda</h3>
              <p className="text-sm text-foreground-600 mb-5">Sfoglia le categorie abbigliamento nel database itaobuy spreadsheet.</p>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all">
                buy it now <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <footer className="border-t border-background-200 pt-8 mt-12">
              <p className="text-xs text-foreground-400"><strong className="text-foreground-500">Itaobuy spreadsheet moda</strong> — <Link to="/" className="text-primary-600 hover:underline">Torna alla home</Link>.</p>
            </footer>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}